import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { estaLogado } from './services/auth';
import Login from './modulos/login';
import Estrutura from './modulos/estrutura';

function RotaProtegida() {
  const [logado, setLogado] = useState(estaLogado());

  useEffect(() => {
    function aoFicarNaoAutorizado() { setLogado(false); }
    window.addEventListener('essensials:unauthorized', aoFicarNaoAutorizado);
    return () => window.removeEventListener('essensials:unauthorized', aoFicarNaoAutorizado);
  }, []);

  if (!logado) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route element={<RotaProtegida />}>
          <Route path="/app/*" element={<Estrutura />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
